import { Loading } from 'components/Loading';
import React from 'react';

export const FullScreenLayout: React.FC<any> = ({ children, activity }) => {
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                height: '100%',
                width: '100%',
                overflowY: 'auto',
                overflowX: 'hidden',
            }}
        >
            <Loading activity={activity} />
            <div
                style={{
                    height: '90%',
                    width: '100%',
                    overflowY: 'auto',
                    overflowX: 'hidden',
                }}
            >
                {children}
            </div>
            <div
                style={{
                    height: '10%',
                    width: '100%',
                    backgroundColor: '#493078',
                    color: '#fff',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                Powered by{' '}
                <img
                    alt="Optechain"
                    src={'/optechain.svg'}
                    style={{ width: '30%', marginLeft: '10px' }}
                />
            </div>
        </div>
    );
};
